import _objectSpread from "@babel/runtime/helpers/objectSpread";
import React from 'react';
import styled from '@emotion/styled';
import sanitizeHtml from 'sanitize-html';
import { Consumer } from '@/store';
var pcTitleColor = 'var(--text-color)';
export default (function (props) {
  return React.createElement(Consumer, null, function (store) {
    var _quest$descKey;
    var _store$state = store.state,
      loading = _store$state.loading,
      quest = _store$state.quest,
      page = _store$state.page,
      questions = _store$state.questions;
    if (loading) return 'loading...';
    var _ref = quest || {},
      header = _ref.header,
      titleHide = _ref.titleHide,
      showProgress = _ref.showProgress,
      bilingual = _ref.bilingual,
      theme = _ref.theme;
    var titleKey = window.showMultiLang ? "".concat(window.language, "Title") : 'title';
    var descKey = window.showMultiLang ? "".concat(window.language, "Desc") : 'desc';
    var _ref2 = quest || {},
      titleColor = _ref2.titleColor;
    if (titleColor === '#2d2d2d') {
      titleColor = pcTitleColor;
    } else if (titleColor === 'var(--text-color)') {
      titleColor = 'var(--title-color)';
    }
    return React.createElement(Header, props, !window.isReport && React.createElement(React.Fragment, null, (header === null || header === void 0 ? void 0 : header.type) === 'url' && (header === null || header === void 0 ? void 0 : header.url) && React.createElement("div", {
      className: "header-pic",
      style: {
        marginTop: showProgress ? 6 : 0
      }
    }, React.createElement("img", {
      src: header.url,
      alt: "header",
      loading: "lazy"
    }))), React.createElement("div", {
      className: "header",
      style: {
        marginTop: "".concat(bilingual ? 3 : showProgress ? 0.4 : 0, "em")
      }
    }, React.createElement("div", {
      id: "title",
      style: {
        color: theme ? 'var(--title-color)' : titleColor,
        display: titleHide ? 'none' : '',
        fontFamily: 'PingFangSC sans-serif Arial Helvetica',
        fontStyle: 'normal',
        fontStretch: 'normal',
        textAlign: 'center'
      }
    }, quest === null || quest === void 0 ? void 0 : quest[titleKey]), React.createElement("div", {
      id: "description",
      style: _objectSpread({
        fontFamily: 'PingFangSC sans-serif Arial Helvetica',
        textAlign: 'left',
        whiteSpace: 'pre-wrap',
        display: page.current !== 1 || !(quest === null || quest === void 0 ? void 0 : quest[descKey]) ? 'none' : '',
        color: 'var(--text-color)'
      }, window.textDirection),
      dangerouslySetInnerHTML: {
        __html: sanitizeHtml((_quest$descKey = quest === null || quest === void 0 ? void 0 : quest[descKey]) !== null && _quest$descKey !== void 0 ? _quest$descKey : '')
      }
    })));
  });
});
var Header = /*#__PURE__*/styled("section", {
  target: "e1f87rac0"
})(".header{overflow:hidden;background:transparent;p{margin-bottom:0;}}.header-pic{position:relative;z-index:1;img{width:100%;}}");